/**
 * Searchbox component - imports custom chip from self repo.
 */
import * as React from 'react';
import { observer, inject } from 'mobx-react';

import './SearchBox.css';
import { PostStore } from '../../../stores/PostStore';
import { toJS, observe, intercept } from 'mobx';

const { default: Chips, Chip } = require('@navrin/react-chips');
const Spinner = require('react-spinkit');

interface SearchBoxProps {
    tags?: string[];
    chippers: string[];
    onChange?: (e: string[]) => void;
}

const Chipper = (value: string) => (
    <Chip 
        theme={{
            chip: 'Search-chip',
            chipSelected: 'Search-chip-selected',
            chipRemove: 'Search-chip-remove',
        }}
    > 
    {value} 
    </Chip>
);

type SearchBoxFullProps = SearchBoxProps & { postStore?: PostStore };

/**
 * Searchbox component, with autocompleted tags and chipped tags.
 * 
 * @export
 * @class SearchBox
 * @extends {React.Component<SearchBoxFullProps>}
 */
@inject((stores) => ({
    postStore: stores.postStore as PostStore,
}))
@observer
export class SearchBox extends React.Component<SearchBoxFullProps> {
    state = {
        chips: toJS(this.props.chippers),
    };

    initialSuggestions = toJS(this.props.postStore!.flatTags);
    
    constructor(props: SearchBoxFullProps) {
        super(props);

        /**
         * observes messages from the taglist (maybe change to a stream?)
         */
        observe(this.props.postStore!.sendChips.add, (change) => {
            this.setState({
                // tslint:disable-next-line:no-any
                chips: [...this.state.chips, ...(change as any).added],
            });
            this.props.postStore!.sendChips.add = [];
        });

        intercept(this.props.postStore!.sendChips, 'override', (change) => {
            this.setState({
                // tslint:disable-next-line:no-any
                chips: [change.newValue],
            });
            return change;
        });   
    }
    
    /**
     * Change listener.
     * 
     * @memberof SearchBox
     */
    onChange = (chips: string[]) => {
        this.props.postStore!.searchQuery.currentInput = '';
        this.props.postStore!.searchQuery.chips = chips;
        // if (this.props.onChange) {
        //     this.props.onChange(chips);
        // }

        this.setState({ chips });
    }

    /**
     * Returns an array of tags that are valid.
     * TODO: Sort by nearest-match?
     * 
     * @memberof SearchBox
     */
    getSuggestions = async (input: string) => {
        this.props.postStore!.searchQuery.currentInput = input;
        return this.props.postStore!.flatTags.filter(t => t.toLowerCase().startsWith(input.toLowerCase()));
    }

    render() {
        return (
            <div>
                <Chips
                    value={this.state.chips}
                    onChange={this.onChange}
                    fetchSuggestions={this.getSuggestions}
                    suggestion={this.initialSuggestions}
                    shouldRenderSuggestions={(value: string) => value.length > 2}
                    createChipKeys={[32, 9, 13, 188]}
                    theme={{
                        chipsContainer: 'Search-chips-container',
                        container: 'Search-container',
                        input: 'Search-input Theme-background',
                        suggestionsList: 'Search-suggestions-list Theme-background',
                        suggestion: 'Search-suggestion',
                        suggestionHighlighted: 'Search-suggestion-highlighted',
                        sectionContainer: 'Search-section-container',
                        sectionTitle: 'Search-section-title',
                        // suggestionsContainer: 'Search-section-container',
                        containerOpen: 'Search-container-open',
                    }}
                    /* highlightFirstSuggestion={true} */
                    placeholder="Enter tags here..."
                    renderChip={Chipper}
                    renderLoading={() => <Spinner name="wave" className="Theme-background" />}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Inputs/SearchBox/SearchBox.tsx